<div class="upload-flow__container">
  <h3 class="upload-flow__title">{{ 'string.upload' | translate }}</h3>
  <cm-file-upload
    [type]="extension"
    (fileChanged)="setCsv($event)"
    (removeFile)="removeFile($event)"
    (downloadErrors)="onDownloadErrors()"
    [fileSizeLimitMB]="fileUploadService.uploadSizeLimitMB"
    [uploadFlow]="true"
    [entityName]="drawerService.data.entity"
    [fileUploadFailed]="_fileUploadFailed"
    [fileHasParsingErrors]="_fileHasParsingError"
    [hideFileUpload]="_fileUploadFailed || _fileHasParsingError"
  ></cm-file-upload>
  <ng-container *ngIf="!_fileUploadFailed; else fileErrorTemplate">
    <ng-container *ngTemplateOutlet="instructionsTemplate"></ng-container>
  </ng-container>
</div>

<ng-template #fileErrorTemplate>
  <div *ngIf="isLoadingErrors && pageIndex === 1" class="spinner-container">
    <mat-spinner id="gridLoader" class="primary-spinner"></mat-spinner>
  </div>
  <div #errorsTable *ngIf="showTable()" class="error-list-table" (scroll)="scrollBreakPoint()">
    <ng-container *ngFor="let error of errorList; let i = index">
      <ng-container *ngFor="let validation of error.validations">
        <div class="error-list-table__column-name grid-item">
          <span>{{ validation.property }}</span>
        </div>
        <div class="error-list-table__column-errors grid-item">
          <span>Row {{ validation._id }}</span>
          <span>{{ parseError(validation) }}</span>
        </div>
      </ng-container>
    </ng-container>
    <mat-progress-bar *ngIf="isLoadingErrors && pageIndex > 1" mode="indeterminate"></mat-progress-bar>
  </div>
  <span *ngIf="_fileHasParsingError && !isLoadingErrors" class="typography__body-1 parsing-template-text"
    >{{ _fileHasParsingErrorDetail || 'file-upload.error-parsing' | translate }}</span
  >
  <ng-container *ngTemplateOutlet="instructionsTemplate"></ng-container>
</ng-template>
<ng-template #instructionsTemplate>
  <h3 class="instructions__header">{{ 'string.instructions' | translate }}</h3>
  <p *ngIf="dataInstructions?.paragraph" class="instructions" [innerHTML]="dataInstructions?.paragraph"></p>
  <div class="template-sample">
    <div class="template-sample__header">
      <!-- <span>{{ 'string.example' | translate }}</span> -->
      <cm-text-button-with-icon
        [color]="BasicButtonColors.PRIMARY"
        [mode]="BasicButtonModes.FLAT"
        [size]="BasicButtonSizes.SMALL"
        (clickEvent)="getTemplate()"
        [label]="'string.downloadTemplate' | translate"
        icon="download"
        data-cy="download-template"
      >
      </cm-text-button-with-icon>
    </div>
    <!-- <img *ngIf="dataInstructions?.image" [src]="dataInstructions?.image" alt="fields-sample" /> -->
  </div>
</ng-template>
